<label class="input-file-label">
    <input #fileInput type="file" class="input-file" (change)="onFilesSelected($event)" accept="image/*" multiple
        hidden />
    <button type="button" class="input-file-button" (click)="fileInput.click()">
        <i class="fa fa-paperclip"></i> Anexar Arquivo
    </button>
</label>